import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Grid,
  Divider,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { Palette, Shield, Gavel, Email, Cookie } from '@mui/icons-material';
import RGPDService from '../services/rgpdService';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.50',
        borderTop: `1px solid ${theme.palette.divider}`,
        mt: 'auto',
        py: isMobile ? 2 : 3,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={isMobile ? 2 : 3} alignItems="center">
          {/* Logo/Nom de la galerie */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: isMobile ? 1 : 0 }}>
              <Palette sx={{ color: 'primary.main', mr: 1 }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: 'primary.main',
                  fontSize: isMobile ? '1rem' : '1.25rem',
                }}
              >
                Noëlle Boronad
              </Typography>
            </Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: isMobile ? '0.75rem' : '0.875rem' }}
            >
              Galerie d'Art — Œuvres originales
            </Typography>
          </Grid>

          {/* Liens légaux */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? 1 : 3,
                alignItems: isMobile ? 'flex-start' : 'center',
              }}
            >
              <Link
                href="/mentions-legales"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                <Gavel sx={{ mr: 0.5, fontSize: '1rem' }} />
                Mentions légales
              </Link>

              <Link
                href="/politique-confidentialite"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                <Shield sx={{ mr: 0.5, fontSize: '1rem' }} />
                Confidentialité
              </Link>

              <Link
                href="/contact-artist"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                <Email sx={{ mr: 0.5, fontSize: '1rem' }} />
                Contact
              </Link>

              <Link
                href="/biographie"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                Biographie
              </Link>

              <Link
                component="button"
                onClick={() => RGPDService.resetBanner()}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                  color: 'text.secondary',
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'primary.main',
                    textDecoration: 'underline',
                  },
                }}
              >
                <Cookie sx={{ mr: 0.5, fontSize: '1rem' }} />
                Gérer les cookies
              </Link>
            </Box>
          </Grid>

          {/* Copyright */}
          <Grid item xs={12} md={3}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                textAlign: isMobile ? 'left' : 'right',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
              }}
            >
              © {currentYear} Galerie d'Art
              <br />
              <Typography
                component="span"
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: isMobile ? '0.7rem' : '0.75rem' }}
              >
                Tous droits réservés
              </Typography>
            </Typography>
          </Grid>
        </Grid>

        {/* Séparateur et info RGPD */}
        {!isMobile && (
          <>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                Ce site respecte votre vie privée et est conforme au RGPD •
                Les œuvres présentées sont protégées par le droit d'auteur
              </Typography>
            </Box>
          </>
        )}
      </Container>
    </Box>
  );
};

export default Footer;
